import React, { Component } from "react";
import { ACCESS_TOKEN } from "../../constants";
import { Redirect } from "react-router-dom";
import { getUrlParameter } from "../../util/DataUtils";

class OAuth2RedirectHandler extends Component {
  render() {
    const token = getUrlParameter("token", this.props.location.search);
    const error = getUrlParameter("error", this.props.location.search);
    if (token) {
      localStorage.setItem(ACCESS_TOKEN, token);
      return (
        <Redirect
          to={{
            pathname: "/profile",
            state: { from: this.props.location },
          }}
        />
      );
    } else {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: {
              from: this.props.location,
              error: error,
            },
          }}
        />
      );
    }
  }
}

export default OAuth2RedirectHandler;



// WEBPACK FOOTER //
// ./src/user/oauth2/OAuth2RedirectHandler.js